import React, { useEffect, useState } from "react";
import { countArray } from "utils/commonHelper";

const FlatList = ({
  data = [],
  renderItem,
  loadingItem,
  numLoading = 5,
  placeholder = null,
  waitForRender = false,
  loading = false,
  onRenderComplete = () => {}, // 👈 NEW callback prop
}) => {
  const [internalLoading, setInternalLoading] = useState(waitForRender);

  useEffect(() => {
    if (waitForRender && data?.length > 0) {
      requestAnimationFrame(() => {
        setInternalLoading(false);
      });
    } else {
      setInternalLoading(false);
    }

    if (waitForRender && (!data || data.length === 0)) {
      setInternalLoading(true);
    }
  }, [data, waitForRender]);

  // Trigger scroll or post-render logic
  useEffect(() => {
    if (!internalLoading && data?.length > 0) {
      onRenderComplete(); // 👈 fire callback once rendering is complete
    }
  }, [internalLoading, data, onRenderComplete]);

  return (
    <>
      {internalLoading || loading ? (
        <>
          {countArray(numLoading).map((item, index, arr) =>
            loadingItem(item, index, arr)
          )}
        </>
      ) : (
        <>
          {data?.length > 0
            ? data.map((item, index, arr) => renderItem(item, index, arr))
            : placeholder}
        </>
      )}
    </>
  );
};

export default FlatList;
